// extracted by mini-css-extract-plugin
export default {"mindMapWrap":"MindMap__mindMapWrap___Wuyaf"};